<template>
  <div class="container live-container">
    <navbar active="live" />
    <live-box />
    <h3 v-if="roomSize > 0">
      <img src="//image.micoworld.net/61f547b6487204a0fb96d587f36a3e46" alt="hot">
      {{ text.hot_live }}
    </h3>
    <list />
  </div>
</template>
<script>
  import Navbar from '../../common/components/Navbar'
  import LiveBox from './LiveBox'
  import List from './List'
  export default {
    components: { Navbar, LiveBox, List },
    data() {
      return {
        roomSize: (window._rooms || []).length || 0
      }
    },
    computed: {
      text() {
        return window.text
      },
    }
  }
</script>
<style lang="less" scoped>
@import "../css/index";
</style>
